import { Component } from '@angular/core';
import { MJAuthBase } from '@memberjunction/ng-auth-services';

@Component({
  selector: 'acs-login-page',
  templateUrl: './login-page.html',
  styleUrls: ['./login-page.scss']
})
export class LoginPageComponent {


  isLoading = false;

  constructor(public authBase: MJAuthBase) { }

  get currentYear(): number {
    return new Date().getFullYear();
  }
}